import React from 'react';

const styles = {
  3: 'col-lg-4 col-md-6 col-xs-6',
  4: 'col-lg-3 col-md-3 col-xs-6',
  6: 'col-lg-2 col-md-2 col-xs-3'
};

export default class List extends React.Component {
  state = {
    selectItem: -1
  };

  select = (index = -1) => {
    if (this.state.selectItem === index) {
      index = -1;
    }
    this.setState({ selectItem: index })
  };

  remove = () => {
    const { removeAction } = this.props;
    removeAction(this.state.selectItem);
    this.select();
  };

  edit = () => {
    const { editAction } = this.props;
    editAction(this.state.selectItem);
    this.select();
  };

  render() {
    const { addAction, component, values = [], number = 4 } = this.props;
    const { selectItem } = this.state;
    const Component = component;
    const style = styles[number];
    return (
      <div className="list-entity">
        <div className="list-entity__actions">
          <button
            onClick={addAction}
            type="button"
            className="btn btn-primary">CREATE
          </button>
          <button
            disabled={selectItem === -1}
            onClick={this.edit}
            type="button" className="btn btn-primary">
            EDIT
          </button>
          <button
            disabled={selectItem === -1}
            onClick={this.remove}
            type="button" className="btn btn-primary">
            REMOVE
          </button>
        </div>
        <hr/>
        <div className="row">
          {
            values.map((values, index) => {
              return (
                <div
                  key={index}
                  className={`list-entity__item ${style}`}
                  onClick={() => {
                    this.select(index);
                  }}>
                  <Component isSelected={selectItem === index} {...values}/>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ListEntity/List.js